module.exports = __webpack_public_path__ + "static/media/fvs_valve1_65.803494c4.jpg";